
export const routes = [
    {
        path: '/',
        label: "Home",
    },
    {
        path: '/about',
        label: "About",
    },
    {
        path: '/services',
        label: "Services",
    },
    {
        path: '/projects',
        label: "Projects",
    },
    {
        path: '/contact',
        label: "Contact us",
    },
]